import React, { useState, useEffect } from "react";
import "./cookieNotice.css"; // Import the CSS file

const CookieNotice = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consentTimestamp = localStorage.getItem("cookieConsent");
    const oneYearInMilliseconds = 365 * 24 * 60 * 60 * 1000;

    if (
      !consentTimestamp ||
      Date.now() - parseInt(consentTimestamp, 10) > oneYearInMilliseconds
    ) {
      // Delay showing the notice by 3 seconds
      const delay = setTimeout(() => {
        setIsVisible(true);
      }, 6000);

      return () => clearTimeout(delay); // Cleanup timeout if component unmounts
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", Date.now().toString());
    setIsVisible(false);
  };

  if (!isVisible) return null; // Don't render if not visible

  return (
    <div className="cookie-notice">
      <p className="cookie-message">
        This website uses cookies and 3rd-party services to offer you a better,
        more personalized, browsing experience with advanced accessibility
        enhancements. By accepting, you agree to the{" "}
        <a href="/cookie-policy/" className="cookie-notice-link">
          Cookie Policy
        </a>{" "}
        and{" "}
        <a href="/privacy-policy/" className="cookie-notice-link">
          Privacy Policy
        </a>{" "}
        of CIC Holdings PLC.
      </p>
      <button onClick={handleAccept} className="cookie-button">
        Accept All
      </button>
    </div>
  );
};

export default CookieNotice;
